type RecipeBodyProps = {
  title: string
  ingredients: string[]
  bodyHtml: string
  shareUrl: string
}

function PrintIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 26 28" fill="currentColor" aria-hidden="true">
      <path d="M6 24h14v-4h-14v4zM6 14h14v-6h-2.5c-0.828 0-1.5-0.672-1.5-1.5v-2.5h-10v10zM24 15c0-0.547-0.453-1-1-1s-1 0.453-1 1 0.453 1 1 1 1-0.453 1-1zM26 15v6.5c0 0.266-0.234 0.5-0.5 0.5h-3.5v2.5c0 0.828-0.672 1.5-1.5 1.5h-15c-0.828 0-1.5-0.672-1.5-1.5v-2.5h-3.5c-0.266 0-0.5-0.234-0.5-0.5v-6.5c0-1.641 1.359-3 3-3h1v-8.5c0-0.828 0.672-1.5 1.5-1.5h10.5c0.828 0 1.969 0.469 2.562 1.062l2.375 2.375c0.594 0.594 1.062 1.734 1.062 2.562v4h1c1.641 0 3 1.359 3 3z" />
    </svg>
  )
}

function MailIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="1" />
      <path d="M3 7l9 7 9-7" />
    </svg>
  )
}

export default function RecipeBody({ title, ingredients, bodyHtml, shareUrl }: RecipeBodyProps) {
  const mailSubject = encodeURIComponent(`Check out this post - ${title}`)
  const mailBody = encodeURIComponent(`Here is the link - ${shareUrl}`)

  return (
    <div data-reveal className="recipe-print-area">
      <div className="recipe-layout">
        <aside className="recipe-ingredients-panel no-print">
          <h2 className="text-caps-h2">Ingredients:</h2>
          <ul className="recipe-ingredients mt-5">
            {ingredients.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <hr className="recipe-divider" />
          <div className="recipe-share">
            <h2 className="text-caps-h2">Share:</h2>
            <a
              href={`mailto:?subject=${mailSubject}&body=${mailBody}`}
              aria-label="Share recipe by email"
              className="recipe-share-email"
            >
              <MailIcon />
            </a>
          </div>
        </aside>

        <div className="recipe-content-panel">
          <div className="recipe-print-header hidden print:block">
            <p className="text-caps-sm text-rose">The It Girl Guide</p>
            <h2 className="mt-2 font-serif text-3xl leading-tight">{title}</h2>
            <h2 className="mt-6 text-caps-h3">Ingredients:</h2>
            <ul className="recipe-ingredients mt-3">
              {ingredients.map((item) => (
                <li key={`print-${item}`}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="recipe-toolbar no-print">
            <span className="text-caps-sm text-rose">TIGG |</span>
            <PrintIcon />
            <button type="button" onClick={() => window.print()} className="recipe-print-button">
              Print recipe
            </button>
          </div>

          <div
            className="article-body recipe-article-body text-copy [&_h2.wp-block-heading]:text-caps-h2 [&_h3.wp-block-heading]:text-caps-h3 [&_a]:text-rose [&_a]:underline [&_a]:underline-offset-2 [&_p]:mb-6 [&_p_em]:italic"
            dangerouslySetInnerHTML={{ __html: bodyHtml }}
          />
        </div>
      </div>
    </div>
  )
}
